import {
  SET_IS_BABY_BOOK,
  LOAD_BABY_BOOK_STATUS } from './../../action-types/bookproperties/';

export const STATE_KEY = 'isBabyBook';

export const isBabyBook = (state = false, action) => {
  switch (action.type) {
    case SET_IS_BABY_BOOK: {
      return action.status;
    }
    case LOAD_BABY_BOOK_STATUS: {
      return action.status;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/isBabyBook.js